import * as React from 'react';

import { productPriceToMonetaryAmount } from 'bundles/coursera-plus-landing-page/utils/productPriceToMonetaryAmount';
import IdealUpgradeEnrollModal from 'bundles/coursera-plus/components/subscriptionTiers/upgradeToPlus/IdealUpgradeEnrollModal';
import IndiaPriceTestUpgradeModal from 'bundles/coursera-plus/components/subscriptionTiers/upgradeToPlus/IndiaUpgrade/IndiaPriceTestUpgradeModal';
import { getIsLearnerImpressedInIndiaTiersEpic } from 'bundles/coursera-plus/utils/subscriptionTiersUtils';
import usePageData from 'bundles/enroll/data/usePageData';

type PropsFromCaller = {
  selectedStep?: 1 | 2 | 3;
  onClose: () => void;
  courseId?: string;
};

const IdealUpgradeEnrollModalContainer = ({ onClose, courseId, selectedStep }: PropsFromCaller) => {
  const { s12n, courseraPlusProductPrice } = usePageData();

  if (getIsLearnerImpressedInIndiaTiersEpic()) {
    return <IndiaPriceTestUpgradeModal onClose={onClose} />;
  }

  const productPrice = courseraPlusProductPrice ? productPriceToMonetaryAmount(courseraPlusProductPrice) : undefined;

  return (
    <IdealUpgradeEnrollModal
      courseraPlusProductPrice={productPrice}
      onClose={onClose}
      courseId={courseId}
      s12nId={s12n?.id}
      selectedStep={selectedStep}
    />
  );
};

export default IdealUpgradeEnrollModalContainer;
